module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAASBAMAAABGPIgdAAAAMFBMVEUAAAD/aZb/aY/6aZH7aY/8aZD9aY/9aZD7aY/8aY/8aY/8aY/9aY/8aY/8aY/8aY/wq9I5AAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAAjElEQVQIHQXBsRHBUAAA0Hf8HJ0/QiYQpVNlAmcCRlAYgFYVJsgZwQZWoHan4OioSYj3SNYLkvUC4dI0u3Bpmj39exx9i0ccVpQDpnVKkTsjbJGtvAF6G2eAbKUcAJa57AC0azofoH9FuYPWa4JuFTG+gWJPeOag841mV8D8lPxSQPIrjgDGdQQQtuAP/OcsWCS1Sv8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/heart.png
// module id = 259
// module chunks = 0